var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Cool event here! "+_vm._s(_vm.event.event.id))]),(_vm.event.timeText)?[_c('b',[_vm._v(_vm._s(_vm.event.timeText))])]:_vm._e(),_c('i',[_vm._v(_vm._s(_vm.event.event.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }